import { consoleLogger } from '../logging/consoleLogger';

export const readCookie = (documentCookie: string, name: string) => {
  const nameString = `${name}=`;
  const cookieString = documentCookie.split(';');
  for (const cookie of cookieString) {
    try {
      let decodedCookie = decodeURIComponent(cookie);
      if (decodedCookie && decodedCookie.includes(nameString)) {
        while (decodedCookie.charAt(0) === ' ') {
          decodedCookie = cookie.substring(1);
        }
        if (decodedCookie.indexOf(nameString) === 0) {
          const cookieValue = decodedCookie.substring(
            nameString.length,
            decodedCookie.length,
          );
          consoleLogger.logDebug(`Cookie ${name} found. Value ${cookieValue}.`);
          return cookieValue;
        }
        consoleLogger.logDebug(
          `Cookie ${name} found, but the value has not been found. Decoded cookie string: ${JSON.stringify(
            decodedCookie,
          )}.`,
        );
        return '';
      }
    } catch (error) {
      if (cookie.includes(nameString)) {
        consoleLogger.logDebug(
          `Cookie can't be decoded string: ${JSON.stringify(
            cookie,
          )} throws the error: ${error}`,
        );
      }
    }
  }

  consoleLogger.logDebug(
    `Decoded cookies string: ${JSON.stringify(
      cookieString,
    )} does not include ${name} cookie. Returning...`,
  );
  return '';
};
